import { defineMessages } from 'react-intl';

export const panelEditorMessages = defineMessages({
  display: {
    id: 'display',
    defaultMessage: 'Display'
  },
  default: {
    id: 'default',
    defaultMessage: 'Default'
  }
});
